import { useState, useEffect } from "react";
import "@/App.css";
import axios from "axios";
import { Menu, X, ShoppingCart, Phone, Mail, MapPin, Instagram, Facebook, Youtube, Star, ChevronRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast, Toaster } from "sonner";
import logo from "../src/assets/logo.png";
import logo1 from "../src/assets/logo.png";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const [products, setProducts] = useState([]);
  // const [testimonials, setTestimonials] = useState([]);
  const [contactForm, setContactForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [activeSection, setActiveSection] = useState("home");
  const WHATSAPP_NUMBER = "918793790136";


  const handleWhatsApp = (product) => {
  const message = `Hello! I am interested in buying the product: ${product.name}. Price: ₹${product.price}`;
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");
};

const handleWhatsAppDirect = () => {
  const message = "Hello! I want to know more about your products.";
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");
};


  // useEffect(() => {
  //   fetchProducts();
  //   fetchTestimonials();
  //   initializeSampleData();
  // }, []);

  // const initializeSampleData = async () => {
  //   try {
  //     const productsResponse = await axios.get(`${API}/products`);
  //     if (productsResponse.data.length === 0) {
  //       const sampleProducts = [
  //         {
  //           name: "Tulsi Honey Jar",
  //           category: "Pure Honey Jars",
  //           description: "0.5kg 100% pure wild honey harvested from pristine forests",
  //           price: 600,
  //           image: "https://images.pexels.com/photos/18581552/pexels-photo-18581552.jpeg",
  //           features: ["Lab Tested", "No Additives", "Raw & Unprocessed"]
  //         },
  //         {
  //           name: " Multi Flora Honey jar",
  //           category: "Pure Honey Jars",
  //           description: "0.5kg Rihivesch organic honey from deep forest ",
  //           price: 550,
  //           image: "https://images.pexels.com/photos/34928357/pexels-photo-34928357.jpeg",
  //           features: ["Organic Certified", "Rich in Antioxidants", "Premium Quality"]
  //         },
  //         {
  //           name: "Jamun Honey Jar",
  //           category: "Honey Moisturiser",
  //           description: "0.5kg Rihivesch organic honey from deep forest",
  //           price: 550,
  //           image: "https://images.pexels.com/photos/6187540/pexels-photo-6187540.jpeg",
  //           features: ["Hydrating", "Anti-aging", "Natural Glow"]
  //         },
  //         {
  //           name: "Honey Rose Soap",
  //           category: "Honey Soap",
  //           description: "100g Luxurious handmade soap with pure Honey Rose and herbs",
  //           price: 130,
  //           image: "https://images.pexels.com/photos/7262990/pexels-photo-7262990.jpeg",
  //           features: ["Handmade", "Chemical-free", "Gentle on Skin"]
  //         },
  //         {
  //           name: "Honey Kesar Chandan",
  //           category: "Honey Face Wash",
  //           description: "100g Gentle face wash with Honey Kesar Chandan for radiant skin",
  //           price: 130,
  //           image: "https://images.pexels.com/photos/6187540/pexels-photo-6187540.jpeg",
  //           features: ["Deep Cleansing", "Brightening", "pH Balanced"]
  //         },
  //         {
  //           name: "Honey Neem & Tulsi",
  //           category: "Honey Gift Hampers",
  //           description: "100g Gentle face wash with Honey neem & Tulsi for radiant skin",
  //           price: 130,
  //           image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
  //           features: ["Premium Packaging", "Perfect Gift", "Variety Pack"]
  //         },
  //         {
  //           name: "Honey Scrub",
  //           category: "Honey-Based Wellness Products",
  //           description: "100g Complete wellness scrub pack with honey supplements",
  //           price: 110,
  //           image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
  //           features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
  //         },
  //         {
  //           name: "Honey Moisturizer",
  //           category: "Honey-Based Wellness Products",
  //           description: "120g Complete wellness pack with honey supplements",
  //           price: 430,
  //           image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
  //           features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
  //         },
  //         {
  //           name: "Honey Lip Balm",
  //           category: "Honey-Based Wellness Products",
  //           description: "100g Complete wellness pack with honey supplements",
  //           price: 130,
  //           image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
  //           features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
  //         }
  //       ];

  //       for (const product of sampleProducts) {
  //         await axios.post(`${API}/products`, product);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error initializing data:", error);
  //   }
  // };

  // const fetchProducts = async () => {
  //   try {
  //     const response = await axios.get(`${API}/products`);
  //     setProducts(response.data);
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   }
  // };

  // const fetchTestimonials = async () => {
  //   try {
  //     const response = await axios.get(`${API}/testimonials`);
  //     if (response.data.length === 0) {
  //       setTestimonials([
  //         {
  //           id: "1",
  //           name: "Priya Sharma",
  //           rating: 5,
  //           comment: "Best honey I've ever tasted! Pure and natural. The quality is outstanding.",
  //           image: null
  //         },
  //         {
  //           id: "2",
  //           name: "Rajesh Kumar",
  //           rating: 5,
  //           comment: "The honey moisturizer transformed my skin. Highly recommend Prakriti products!",
  //           image: null
  //         },
  //         {
  //           id: "3",
  //           name: "Anita Desai",
  //           rating: 5,
  //           comment: "Authentic and pure honey. The packaging is beautiful too. Worth every penny!",
  //           image: null
  //         }
  //       ]);
  //     } else {
  //       setTestimonials(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching testimonials:", error);
  //   }
  // };

  const products = [
          {
            id: 1,
            name: "Tulsi Honey Jar",
            category: "Pure Honey Jars",
            description: "0.5kg 100% pure wild honey harvested from pristine forests",
            price: 600,
            image: "https://images.pexels.com/photos/18581552/pexels-photo-18581552.jpeg",
            features: ["Lab Tested", "No Additives", "Raw & Unprocessed"]
          },
          {
            id: 2,
            name: " Multi Flora Honey jar",
            category: "Pure Honey Jars",
            description: "0.5kg Rihivesch organic honey from deep forest ",
            price: 550,
            image: "https://images.pexels.com/photos/34928357/pexels-photo-34928357.jpeg",
            features: ["Organic Certified", "Rich in Antioxidants", "Premium Quality"]
          },
          {
            id: 3,
            name: "Jamun Honey Jar",
            category: "Honey Moisturiser",
            description: "0.5kg Rihivesch organic honey from deep forest",
            price: 550,
            image: "https://images.pexels.com/photos/6187540/pexels-photo-6187540.jpeg",
            features: ["Hydrating", "Anti-aging", "Natural Glow"]
          },
          {
            id: 4,
            name: "Honey Rose Soap",
            category: "Honey Soap",
            description: "100g Luxurious handmade soap with pure Honey Rose and herbs",
            price: 130,
            image: "https://images.pexels.com/photos/7262990/pexels-photo-7262990.jpeg",
            features: ["Handmade", "Chemical-free", "Gentle on Skin"]
          },
          {
            id: 5,
            name: "Honey Kesar Chandan",
            category: "Honey Face Wash",
            description: "100g Gentle face wash with Honey Kesar Chandan for radiant skin",
            price: 130,
            image: "https://images.pexels.com/photos/6187540/pexels-photo-6187540.jpeg",
            features: ["Deep Cleansing", "Brightening", "pH Balanced"]
          },
          {
            id: 6,
            name: "Honey Neem & Tulsi",
            category: "Honey Gift Hampers",
            description: "100g Gentle face wash with Honey neem & Tulsi for radiant skin",
            price: 130,
            image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
            features: ["Premium Packaging", "Perfect Gift", "Variety Pack"]
          },
          {
            id: 7,
            name: "Honey Scrub",
            category: "Honey-Based Wellness Products",
            description: "100g Complete wellness scrub pack with honey supplements",
            price: 110,
            image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
            features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
          },
          {
            id: 8,
            name: "Honey Moisturizer",
            category: "Honey-Based Wellness Products",
            description: "120g Complete wellness pack with honey supplements",
            price: 430,
            image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
            features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
          },
          {
            id: 9,
            name: "Honey Lip Balm",
            category: "Honey-Based Wellness Products",
            description: "100g Complete wellness pack with honey supplements",
            price: 130,
            image: "https://images.pexels.com/photos/14168472/pexels-photo-14168472.jpeg",
            features: ["Immunity Booster", "Energy Pack", "Natural Healing"]
          }
        ];

  const testimonials = [
          {
            id: 1,
            name: "Priya Sharma",
            rating: 5,
            comment: "Best honey I've ever tasted! Pure and natural. The quality is outstanding.",
            image: null
          },
          {
            id: 2,
            name: "Rajesh Kumar",
            rating: 5,
            comment: "The honey moisturizer transformed my skin. Highly recommend Prakriti products!",
            image: null
          },
          {
            id: 3,
            name: "Anita Desai",
            rating: 5,
            comment: "Authentic and pure honey. The packaging is beautiful too. Worth every penny!",
            image: null
          }
        ];


  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/contact`, contactForm);
      toast.success("Message sent successfully! We'll get back to you soon.");
      setContactForm({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      toast.error("Failed to send message. Please try again.");
    }
  };

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/newsletter`, { email: newsletterEmail });
      toast.success("Successfully subscribed to newsletter!");
      setNewsletterEmail("");
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error("Email already subscribed!");
      } else {
        toast.error("Failed to subscribe. Please try again.");
      }
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
      setIsMenuOpen(false);
    }
  };

  const categories = [
    { name: "Pure Honey Jars", icon: "🍯" },
    { name: "Honey Moisturiser", icon: "💧" },
    { name: "Honey Soap", icon: "🧼" },
    { name: "Honey Scrub", icon: "🧴" },
    { name: "Honey Lip Balm", icon: "✨" },
    { name: "Honey Gift Hampers", icon: "🎁" }
  ];

  const benefits = [
    { title: "Boosts Immunity", description: "Rich in antioxidants and enzymes", icon: "💪" },
    { title: "Improves Digestion", description: "Natural prebiotic properties", icon: "🌟" },
    { title: "Natural Energy", description: "Instant and sustained energy boost", icon: "⚡" },
    { title: "Skin & Hair Care", description: "Natural moisturizer and healer", icon: "✨" },
    { title: "Anti-bacterial", description: "Natural healing properties", icon: "🛡️" },
    { title: "Weight Management", description: "Healthy sugar alternative", icon: "⚖️" }
  ];

  const usps = [
    { title: "Pure & Unprocessed", description: "100% raw honey, no additives" },
    { title: "Direct from Beekeepers", description: "Ethical sourcing practices" },
    { title: "Lab Tested", description: "Certified quality assurance" },
    { title: "Boosts Immunity", description: "Rich in natural enzymes" },
    { title: "Health Benefits", description: "Skin, hair & wellness" },
    { title: "Eco-friendly", description: "Sustainable packaging" }
  ];

  const reels = [
    { id: 1, thumbnail: "https://images.unsplash.com/photo-1758522966091-4c7b94b5c3de", link: "https://instagram.com/prakriti_honey" },
    { id: 2, thumbnail: "https://images.unsplash.com/photo-1730190168042-3bef4553a8f4", link: "https://instagram.com/prakriti_honey" },
    { id: 3, thumbnail: "https://images.unsplash.com/photo-1758522965914-6a746d870502", link: "https://instagram.com/prakriti_honey" },
    { id: 4, thumbnail: "https://images.pexels.com/photos/5247987/pexels-photo-5247987.jpeg", link: "https://instagram.com/prakriti_honey" },
    { id: 5, thumbnail: "https://images.pexels.com/photos/19143147/pexels-photo-19143147.jpeg", link: "https://instagram.com/prakriti_honey" },
    { id: 6, thumbnail: "https://images.pexels.com/photos/5247981/pexels-photo-5247981.jpeg", link: "https://instagram.com/prakriti_honey" }
  ];

  return (
    <div className="app-container">
      <Toaster position="top-right" richColors />
      
      {/* Animated Bee */}
      <div className="floating-bee" />
      
      {/* Header */}
      <header className="header" data-testid="main-header">
        <div className="header-content">
          <div className="logo" data-testid="logo">
         <img src={logo} 
      className="h-16 w-28 drop-shadow-[0_0_40px_white]"
    />
    </div>

          
          <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`} data-testid="nav-menu">
            <a onClick={() => scrollToSection('home')} data-testid="nav-home">Home</a>
            <a onClick={() => scrollToSection('about')} data-testid="nav-about">About Us</a>
            <a onClick={() => scrollToSection('products')} data-testid="nav-products">Products</a>
            <a onClick={() => scrollToSection('benefits')} data-testid="nav-benefits">Benefits</a>
            <a onClick={() => scrollToSection('reels')} data-testid="nav-reels">Reels</a>
            <a onClick={() => scrollToSection('testimonials')} data-testid="nav-testimonials">Testimonials</a>
            <a onClick={() => scrollToSection('contact')} data-testid="nav-contact">Contact</a>
            <Button
              className="shop-btn"
              onClick={handleWhatsAppDirect}
              data-testid="nav-shop-btn"
            >
              <ShoppingCart className="w-4 h-4" /> Shop Now
            </Button>
          </nav>

          <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)} data-testid="menu-toggle">
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section" id="home" data-testid="hero-section">
        <div className="hero-glow" />
        <div className="hero-content">
          <div className="hero-text h-full lg:mt-[50%]">
            <h1 className="hero-title text-9xl md:text-8xl font-extrabold" data-testid="hero-title">
              100%
            </h1>
            <h1 className="hero-title" data-testid="hero-title">
              Pure. Natural. Divine.
            </h1>
            <p className="hero-subtitle" data-testid="hero-subtitle">
              Prakriti Honey – From Nature to Your Home
            </p>
            <div className="hero-buttons">
              <Button className="hero-btn-primary" onClick={() => scrollToSection('products')} data-testid="hero-shop-btn">
                Shop Products <ChevronRight className="w-5 h-5" />
              </Button>
              <Button className="hero-btn-secondary" onClick={() => scrollToSection('benefits')} data-testid="hero-benefits-btn">
                Explore Benefits <Sparkles className="w-5 h-5" />
              </Button>
            </div>
          </div>
          <div className="hero-image">
            <div className="honey-jar-container">
              <img src="https://www.shutterstock.com/image-photo/honey-dipper-spoon-completely-filled-600nw-2581641081.jpg" alt="Premium Honey Jar" className="honey-jar" data-testid="hero-honey-jar" />
              <div className="honey-drip" />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about" data-testid="about-section">
        <div className="section-container">
          <div className="about-grid">
            <div className="about-images">
              <img src="https://images.pexels.com/photos/5247987/pexels-photo-5247987.jpeg" alt="Beekeeping" className="about-img" data-testid="about-img-1" />
              <img src="https://images.unsplash.com/photo-1758522966091-4c7b94b5c3de" alt="Honey Harvesting" className="about-img" data-testid="about-img-2" />
            </div>
            <div className="about-content">
              <h2 className="section-title" data-testid="about-title">Our Story</h2>
              <p className="about-text">
                Prakriti Honey is dedicated to bringing you the purest, most natural honey directly from ethical beekeepers. 
                Our honey is extracted from pristine natural sources, ensuring every drop is chemical-free and rich in natural goodness.
              </p>
              <div className="highlight-points">
                <div className="highlight-item" data-testid="highlight-pure">
                  <div className="highlight-icon">✓</div>
                  <div>
                    <h4>100% Pure & Lab Tested</h4>
                    <p>Certified quality you can trust</p>
                  </div>
                </div>
                <div className="highlight-item" data-testid="highlight-ethical">
                  <div className="highlight-icon">✓</div>
                  <div>
                    <h4>Ethical Beekeeping</h4>
                    <p>Supporting sustainable practices</p>
                  </div>
                </div>
                <div className="highlight-item" data-testid="highlight-natural">
                  <div className="highlight-icon">✓</div>
                  <div>
                    <h4>No Artificial Sugar</h4>
                    <p>100% raw and unprocessed</p>
                  </div>
                </div>
                <div className="highlight-item" data-testid="highlight-enzymes">
                  <div className="highlight-icon">✓</div>
                  <div>
                    <h4>Rich Enzymes & Antioxidants</h4>
                    <p>Maximum health benefits</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Categories */}
      <section className="categories-section" data-testid="categories-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="categories-title">Our Product Range</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
            {categories.map((cat, index) => (
              <div key={index} className="category-card" onClick={() => scrollToSection('products')} data-testid={`category-card-${index}`}>
                <div className="category-icon">{cat.icon}</div>
                <h3>{cat.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products Showcase */}
      <section className="products-section" id="products" data-testid="products-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="products-title">Premium Products</h2>
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card" data-testid={`product-card-${product.id}`}>
                <div className="product-image-wrapper">
                  <img src={product.image} alt={product.name} className="product-image" />
                  {/* <div className="product-overlay">
                    <Button className="overlay-btn" data-testid={`view-details-btn-${product.id}`}>View Details</Button>
                  </div> */}
                </div>
                <div className="product-info">
                  <span className="product-category">{product.category}</span>
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  <div className="product-features">
                    {product.features.map((feature, idx) => (
                      <span key={idx} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                  <div className="product-footer">
                    <span className="product-price">₹{product.price}</span>
                    <Button
                      className="add-to-cart-btn"
                      onClick={() => handleWhatsApp(product)}
                      data-testid={`add-to-cart-btn-${product.id}`}
                    >
                      <ShoppingCart className="w-4 h-4" /> Shop now
                    </Button>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* USP Section */}
      <section className="usp-section" data-testid="usp-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="usp-title">Why Choose Prakriti Honey?</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
            {usps.map((usp, index) => (
              <div key={index} className="usp-card" data-testid={`usp-card-${index}`}>
                <div className="usp-icon">✨</div>
                <h3>{usp.title}</h3>
                <p>{usp.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section" id="benefits" data-testid="benefits-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="benefits-title">Health Benefits of Pure Honey</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card" data-testid={`benefit-card-${index}`}>
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reels Section */}
      <section className="reels-section" id="reels" data-testid="reels-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="reels-title">Our Latest Reels</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
            {reels.map((reel) => (
              <a
                key={reel.id}
                href={reel.link}
                target="_blank"
                rel="noopener noreferrer"
                className="reel-card"
                data-testid={`reel-card-${reel.id}`}
              >
                <img src={reel.thumbnail} alt={`Reel ${reel.id}`} className="reel-thumbnail" />
                <div className="reel-overlay">
                  <div className="play-icon">▶</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section" id="testimonials" data-testid="testimonials-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="testimonials-title">What Our Customers Say</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card" data-testid={`testimonial-card-${testimonial.id}`}>
                <div className="stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="star-icon" fill="#F7B500" strokeWidth={0} />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.comment}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.name.charAt(0)}</div>
                  <span className="author-name">{testimonial.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact" data-testid="contact-section">
        <div className="section-container">
          <h2 className="section-title text-center" data-testid="contact-title">Contact & Visit Us</h2>
          <div className="contact-grid">
            <div className="contact-info">
              <div className="contact-item" data-testid="contact-phone">
                <Phone className="contact-icon" />
                <div>
                  <h4>Phone</h4>
                  <p>+91 87937 90136</p>
                </div>
              </div>
              <div className="contact-item" data-testid="contact-email">
                <Mail className="contact-icon" />
                <div>
                  <h4>Email</h4>
                  <p>prakritihoney.pune@gmail.com</p>
                </div>
              </div>
              <div className="contact-item" data-testid="contact-address">
                <MapPin className="contact-icon" />
                <div>
                  <h4>Address</h4>
                  <p>Kunal Icon Rd, pimple Saudagar, Pune, 20Maharashtra, 411027</p>
                </div>
              </div>
              <div className="whatsapp-btn-wrapper">
                  <a
                    href="https://wa.me/8793790136"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button className="whatsapp-btn" data-testid="whatsapp-btn">
                      <Phone className="w-4 h-4" /> WhatsApp Us
                    </Button>
                  </a>
                </div>

            </div>
            <form className="contact-form" onSubmit={handleContactSubmit} data-testid="contact-form">
              <Input
                placeholder="Your Name"
                value={contactForm.name}
                onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                required
                data-testid="contact-form-name"
              />
              <Input
                type="email"
                placeholder="Your Email"
                value={contactForm.email}
                onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                required
                data-testid="contact-form-email"
              />
              <Input
                placeholder="Phone Number"
                value={contactForm.phone}
                onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}
                required
                data-testid="contact-form-phone"
              />
              <Textarea
                placeholder="Your Message"
                value={contactForm.message}
                onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                required
                rows={4}
                data-testid="contact-form-message"
              />
              <Button type="submit" className="submit-btn" data-testid="contact-form-submit">
                Send Message
              </Button>
            </form>
          </div>
          <div className="map-container" data-testid="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4219.9896014427595!2d73.78844870321872!3d18.592823590438826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b929cc80d267%3A0x335f4747ff0e154c!2sPrakriti%20Honey!5e0!3m2!1sen!2sin!4v1764417801590!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo" data-testid="footer-logo">
              <img src={logo1} className="h-24 w-36"/>
            </div>
            <p className="footer-tagline">From Nature's Lap To Your Home</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <a onClick={() => scrollToSection('home')}>Home</a>
            <a onClick={() => scrollToSection('about')}>About Us</a>
            <a onClick={() => scrollToSection('products')}>Products</a>
            <a onClick={() => scrollToSection('contact')}>Contact</a>
          </div>
          
          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-icons">
              <a href="https://instagram.com/prakriti_honey" target="_blank" rel="noopener noreferrer" data-testid="social-instagram">
                <Instagram className="social-icon" />
              </a>
              <a href="https://instagram.com/prakriti_honey" target="_blank" rel="noopener noreferrer" data-testid="social-facebook">
                <Facebook className="social-icon" />
              </a>
              <a href="https://instagram.com/prakriti_honey" target="_blank" rel="noopener noreferrer" data-testid="social-youtube">
                <Youtube className="social-icon" />
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Newsletter</h4>
            <form onSubmit={handleNewsletterSubmit} className="newsletter-form" data-testid="newsletter-form">
              <Input
                type="email"
                placeholder="Your email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                required
                className="newsletter-input"
                data-testid="newsletter-input"
              />
              <Button type="submit" className="newsletter-btn" data-testid="newsletter-submit">
                Subscribe
              </Button>
            </form>
          </div>
        </div>
        
        <div className="footer-bottom flex justify-between items-center border-t border-white/20 py-4">
          <p className="text-sm">© 2025 Prakriti Honey. All rights reserved.</p>
          <p className="text-sm font-medium">Designed By <a href="https://x7ittechnologies.com" target="_blank" className="text-sm font-medium hover:text-blue-500 transition-colors duration-200" rel="noopener noreferrer">X7 IT Technologies</a></p>
        </div>

      </footer>
    </div>
  );
}

export default App;
